export default {"src":"/_next/static/media/step1.fecd4363.svg","height":68,"width":58};